// extracted by mini-css-extract-plugin
module.exports = {"button":"DisplayModeSelector_button__r_7sZ","openButton":"DisplayModeSelector_openButton__1I-Et","menuIcon":"DisplayModeSelector_menuIcon__1a0nm"};